import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import {
  Button,
  Divider,
  Form,
  Grid,
  Header,
  Icon,
  Modal,
} from 'semantic-ui-react';
import DateTimePicker from '../../components/DateTimePicker';

moment.locale('en-gb');

const inputDateFormat = 'DD/MM/YYYY, hh:mm A';

export default class TierPricingSchedule extends Component {
  static propTypes = {
    data: PropTypes.shape({
      scheduleStartAt: PropTypes.string,
      scheduleEndAt: PropTypes.string,
      name: PropTypes.string,
    }),
    headerNode: PropTypes.node,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
    open: PropTypes.bool,
    scrolling: PropTypes.bool,
  }
  constructor(props) {
    super(props);
    const data = Object.assign({
      scheduleStartAt: null,
      scheduleEndAt: null,
      name: '',
    }, props.data || {});
    this.state = {
      data,
      visibleStart: false,
      visibleEnd: false,
    };
  }
  componentWillReceiveProps(nextProps) {
    const data = Object.assign({
      scheduleStartAt: null,
      scheduleEndAt: null,
      name: '',
    }, nextProps.data || {});
    this.setState({
      data,
    });
  }
  handleOnClose = (e) => {
    if (this.props.onClose) {
      this.props.onClose(e);
    }
  }
  handleOnComfirm = (e) => {
    e.preventDefault();
    const { data } = this.state;
    // remove timezone from date object (because API server has default timezone set)
    if (data.scheduleStartAt) data.scheduleStartAt = `${moment(data.scheduleStartAt).format('YYYY-MM-DDTHH:mm:ss')}Z`;
    if (data.scheduleEndAt) data.scheduleEndAt = `${moment(data.scheduleEndAt).format('YYYY-MM-DDTHH:mm:ss')}Z`;
    if (this.props.onConfirm) {
      this.props.onConfirm(e, data);
    }
  }
  handleOnVisible = (visibleID) => {
    const states = this.state;
    states.visibleStart = false;
    states.visibleEnd = false;
    states[visibleID] = true;
    this.setState(states);
  }
  handleOnHide = (visibleID) => {
    this.setState({ [visibleID]: false });
  }
  handleHideAll = () => {
    const states = this.state;
    states.visibleStart = false;
    states.visibleEnd = false;
    this.setState(states);
  }
  handleOnClear = (e, visibleID) => {
    const { data } = this.state;
    if (visibleID === 'scheduleStartAt') {
      data.scheduleStartAt = null;
    } else if (visibleID === 'scheduleEndAt') {
      data.scheduleEndAt = null;
    }
    this.setState({ data, [visibleID]: false });
  }
  handleOnChange = (value, id, visible) => {
    const { data } = this.state;
    let { visibleStart, visibleEnd } = this.state;
    if (id === 'scheduleStartAt') {
      visibleStart = visible;
    } else if (id === 'scheduleEndAt') {
      visibleEnd = visible;
    }
    data[id] = value;
    this.setState({ data, [id]: value, visibleStart, visibleEnd });
  }
  render() {
    const { data, visibleStart, visibleEnd } = this.state;
    return (
      <Modal
        open={this.props.open}
        onClose={this.handleOnClose}
        size="tiny"
        closeOnDimmerClick={false}
      >
        <Header onClick={() => this.handleHideAll()}>
          <Icon name="calendar" />
          <Header.Content>
            {this.props.headerNode || 'Schedule Pricing'}
            <Header.Subheader>{data.name && data.name}</Header.Subheader>
          </Header.Content>
        </Header>
        <Modal.Content scrolling={this.props.scrolling || false}>
          <Grid centered>
            <Grid.Row>
              <Grid.Column mobile={16} tablet={16} computer={2} className="small-hide tablet-hide" onClick={() => this.handleHideAll()} />
              <Grid.Column mobile={16} tablet={16} computer={12}>
                <div className="ui form">
                  <Form.Group widths="equal">
                    <Form.Input
                      fluid
                      label="Start At"
                      placeholder="Click to setup"
                      value={data.scheduleStartAt ? moment(data.scheduleStartAt).format(inputDateFormat) : ''}
                      readOnly
                      onFocus={() => this.handleOnVisible('visibleStart')}
                      icon={
                        data.scheduleStartAt ?
                          <Icon
                            color="red"
                            link
                            name="x"
                            onClick={e => this.handleOnClear(e, 'scheduleStartAt')}
                            title="Clear"
                          />
                          : null
                      }
                    />
                  </Form.Group>
                  <DateTimePicker
                    maxDate={data.scheduleEndAt && data.scheduleEndAt}
                    noPadding
                    onChange={(value, visible) => this.handleOnChange(value, 'scheduleStartAt', visible)}
                    value={data.scheduleStartAt ? moment(data.scheduleStartAt).toDate() : ''}
                    visible={visibleStart}
                  />
                  <Divider />
                  <Form.Group widths="equal">
                    <Form.Input
                      fluid
                      label="End At"
                      placeholder="Click to setup"
                      value={data.scheduleEndAt ? moment(data.scheduleEndAt).format(inputDateFormat) : ''}
                      readOnly
                      onFocus={() => this.handleOnVisible('visibleEnd')}
                      icon={
                        data.scheduleEndAt ?
                          <Icon
                            color="red"
                            link
                            name="x"
                            onClick={e => this.handleOnClear(e, 'scheduleEndAt')}
                            title="Clear"
                          />
                          : null
                      }
                    />
                  </Form.Group>
                  <DateTimePicker
                    minDate={data.scheduleStartAt && data.scheduleStartAt}
                    onChange={(value, visible) => this.handleOnChange(value, 'scheduleEndAt', visible)}
                    noPadding
                    value={data.scheduleEndAt ? moment(data.scheduleEndAt).toDate() : ''}
                    visible={visibleEnd}
                  />
                </div>
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={2} className="small-hide tablet-hide" onClick={() => this.handleHideAll()} />
            </Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Actions onClick={() => this.handleHideAll()}>
          <Button onClick={this.handleOnClose} icon="cancel" content="Cancel" />
          <Button color="blue" onClick={this.handleOnComfirm} icon="save" content="Save" />
        </Modal.Actions>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/modals/TierPricingSchedule.jsx